/**
 * Tenant-related constants used across selectors and thunks.
 */

/** `hint` value identifying the global tenant entry inside `userInfo.ext.tenantId`. */
export const GLOBAL_TENANT_HINT = "global"

/** Tenant id assigned to the super admin (zero UUID). */
export const SUPER_ADMIN_TENANT_ID = "00000000-0000-0000-0000-000000000000"
